import { render, staticRenderFns } from "./exchange4.vue?vue&type=template&id=79e7de1e&scoped=true&"
import script from "./exchange4.vue?vue&type=script&lang=js&"
export * from "./exchange4.vue?vue&type=script&lang=js&"
import style0 from "./exchange4.vue?vue&type=style&index=0&id=79e7de1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e7de1e",
  null
  
)

export default component.exports